import React from "react";
import styles from "./Footer.module.scss";
import { useMenu } from "../menu/useMenu";
import { TabKeys } from "../../data/tabs";

export const FooterComponent: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { onTabSelected } = useMenu();

  return (
    <footer className={styles["footer"]}>
      <div className={styles["copyright"]}>
        &copy; {currentYear} Volumetric Labs. All rights reserved.
      </div>
      <div className={styles["links"]}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onTabSelected(TabKeys.PrivacyPolicy);
            window.scrollTo(0, 0);
          }}>
          Privacy Policy
        </a>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onTabSelected(TabKeys.TermsAndConditions);
            window.scrollTo(0, 0);
          }}>
          Terms of Service
        </a>
        <a
          href="https://github.com/v0lum3tric"
          target="_blank"
          rel="noopener noreferrer">
          GitHub
        </a>
        <a
          href="https://www.linkedin.com/company/volumetric-labs/"
          target="_blank"
          rel="noopener noreferrer">
          LinkedIn
        </a>
      </div>
    </footer>
  );
};
